import React from "react";
// motion
import { motion } from "framer-motion";
// variants
import { fadeIn } from "../variants";
// img
import Img1 from "../assets/reactss.png";
import Img2 from "../assets/calculatorapp.png";
import Img3 from "../assets/basicprojext.png";

const Work = () => {
  return (
    <section className="section" id="work">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row gap-x-10">
          <motion.div
            variants={fadeIn("right", 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0"
          >
            {/* text */}
            <div>
              <h2 className="h2 leading-tight text-accent">
                My Latest <br />
                work.
              </h2>
              <p className="max-w-sm mb-16">
                Overall, with my experience at Forever Club, Bizquesta, and
                Bizgurukul, I bring a strong foundation in digital marketing, a
                results-driven mindset, and a passion for leveraging digital
                channels to achieve business growth and success. I am committed
                to staying updated with industry trends and best practices to
                deliver impactful marketing strategies and drive measurable
                results for businesses.
              </p>
              {/* <button className="btn btn-sm" id="buttonisnotworkingvaaliid">View all projects</button> */}
            </div>
            {/* image */}
            <div className="group relative overflow-hidden border-2 border-white/50 round-xl">
              {/* overlay */}
              <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
              {/* image */}
              <a href="#">
                <img
                  className="group-hover:scale-125 transition-all duration-500"
                  src={Img1}
                  alt=""
                />
              </a>
              {/* pretittle */}
              <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                <span className="text-gradient">UI/UX Design</span>
              </div>
              {/* title */}
              <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                <a href="#" target="_blank">
                  <span className="text-3xl text-white">
                    Personal PortFolio
                  </span>
                </a>
              </div>
            </div>
          </motion.div>
          <motion.div
            variants={fadeIn("left", 0.2)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 flex flex-col gap-y-10"
          >
            <div className="group relative overflow-hidden border-2 border-white/50 round-xl">
              {/* overlay */}
              <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
              {/* image */}
              <img
                className="group-hover:scale-125 transition-all duration-500"
                src={Img2}
                alt=""
              />
              {/* pretittle */}
              <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                <span className="text-gradient">React-JS</span>
              </div>
              {/* title */}
              <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                <a
                  href="https://github.com/wasiuddinmansoori1/calculator-react-/blob/main/src/App.js"
                  target="_blank"
                >
                  {" "}
                  <span className="text-3xl text-white">Calculator</span>
                </a>
              </div>
            </div>
            <div className="group relative overflow-hidden border-2 border-white/50 round-xl">
              {/* overlay */}
              <div className="group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300"></div>
              {/* image */}
              <img
                href="https://wasiuddin.w3spaces.com/"
                className="group-hover:scale-125 transition-all duration-500"
                src={Img3}
                alt=""
              />
              {/* pretittle */}
              <div className="absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50">
                <span className="text-gradient">HTML-CSS-JS</span>
              </div>
              {/* title */}
              <div className="absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50">
                <a href="https://wasiuddin.w3spaces.com/" target="_blank">
                  <span className="text-3xl text-white">Basic-Portfolio</span>
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Work;
